import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCpu = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeWidth: 1.5,
		d: "M10 3V1.75m0 16.5V17M1.75 9.625H3m14 0h1.25M6.25 3V1.75m0 16.5V17M1.75 5.875H3m14 0h1.25M13.75 3V1.75m0 16.5V17m-12-3.625H3m14 0h1.25M4.95 16.25h10.1c.42 0 .63 0 .79-.082a.751.751 0 0 0 .328-.327c.082-.16.082-.371.082-.791V4.95c0-.42 0-.63-.082-.79a.75.75 0 0 0-.327-.328c-.16-.082-.371-.082-.791-.082H4.95c-.42 0-.63 0-.79.082a.75.75 0 0 0-.328.328c-.082.16-.082.37-.082.79v10.1c0 .42 0 .63.082.79a.75.75 0 0 0 .328.328c.16.082.37.082.79.082Zm2.7-3.5h4.7c.14 0 .21 0 .264-.027a.251.251 0 0 0 .109-.11c.027-.053.027-.123.027-.263v-4.7c0-.14 0-.21-.027-.264a.25.25 0 0 0-.11-.109c-.053-.027-.123-.027-.263-.027h-4.7c-.14 0-.21 0-.264.027a.25.25 0 0 0-.109.11c-.027.053-.027.123-.027.263v4.7c0 .14 0 .21.027.264a.25.25 0 0 0 .11.109c.053.027.123.027.263.027Z"
	})]
});
const ForwardRef = forwardRef(SvgCpu);
export { ForwardRef as ReactComponent };
